import React, { useState, useCallback, useEffect } from "react";
import SkillItem from "../../steps/Skills/SkillItem";
import SkillForm from "../../steps/Skills/SkillsForm";
import { useDispatch } from 'react-redux';
import { showModal } from '../../../../redux/system/actions';
import ConfirmModal from "../../../common/modals/ConfirmModal";
import { createMultipleCurriculumVitaeSkills, updateCurriculumVitaeSkill } from "../../../../api/curriculumVitaeApi";
import { toast } from 'react-toastify';
import {COMPLETE_CURRICULUM_VITAE_SKILL_TOAST_MESSAGES, getErrorUpdateToastPropsBy, getSuccesToastPropsBy} from '../../../../service/toastService';
import SkillsList from "../../steps/Skills/SkillsList";

const CONFIRM_MODAL_ID = 'confirmModal';

function SkillMainMenu({ curriculumVitae, setCurriculumVitae, handleDeleteItem, status }) {
    const dispatch = useDispatch();
    const handleShowModal = useCallback((modalId) => dispatch(showModal(modalId)), [dispatch]);

    const [skills, setSkills] = useState(curriculumVitae.curriculumVitaeSkills || []);
    const [skillToDelete, setSkillToDelete] = useState(null);
    const [editingSkill, setEditingSkill] = useState(null);
    const [addingSkill, setAddingSkill] = useState(false);

    useEffect(() => {
        setSkills(curriculumVitae.curriculumVitaeSkills || []);
    }, [curriculumVitae.curriculumVitaeSkills]);

    const handleSaveSkill = async (skillData) => {
        try {
            if (editingSkill) {
                const updatedSkillData = {
                    ...skillData,
                    skillName: skillData.skillName[0]
                };
        
                const updatedSkill = await updateCurriculumVitaeSkill(updatedSkillData);
                const updatedSkills = skills.map((skill) =>
                    skill.id === skillData.id ? updatedSkill.data : skill
                );
        
                setSkills(updatedSkills);
                setCurriculumVitae((prevCv) => ({
                    ...prevCv,
                    curriculumVitaeSkills: updatedSkills,
                }));
                toast.success('Skill updated successfully!', getSuccesToastPropsBy(COMPLETE_CURRICULUM_VITAE_SKILL_TOAST_MESSAGES));
            } else {
                const formattedSkills = skillData.skillName.map((skill) => ({
                    skillName: skill,
                    skillType: skillData.skillType,
                    skillRating: skillData.skillRating,
                    curriculumVitaeId: skillData.curriculumVitaeId,
                }));
        
                const newSkills = await createMultipleCurriculumVitaeSkills(formattedSkills);
                const updatedSkills = [...skills, ...newSkills.data];
        
                setSkills(updatedSkills);
                setCurriculumVitae((prevCv) => ({
                    ...prevCv,
                    curriculumVitaeSkills: updatedSkills,
                }));
                toast.success('Skills added successfully!', getSuccesToastPropsBy(COMPLETE_CURRICULUM_VITAE_SKILL_TOAST_MESSAGES));
            }
        
            setEditingSkill(null);
            setAddingSkill(false);
        } catch (error) {
            toast.error('Something went wrong! Please try again.', getErrorUpdateToastPropsBy(COMPLETE_CURRICULUM_VITAE_SKILL_TOAST_MESSAGES));
            setEditingSkill(null);
        }
    };

    const handleEditSkill = (skill) => {
        setEditingSkill(skill);
    };

    const confirmDeleteSkill = (skillId) => {
        setSkillToDelete(skillId);
        handleShowModal(CONFIRM_MODAL_ID);
    };

    return (
        <div className="cv-main-menu-overview">
            {(editingSkill || addingSkill) ? (
                <>
                    <h3 className="cv-main-menu-edit-mode">
                        {editingSkill ? 'Edit Mode' : 'Add Skill'}
                    </h3>
                    <div className="main-menu-form-wrapper">
                        <SkillForm
                            curriculumVitaeId={curriculumVitae.id}
                            initialSkill={editingSkill}
                            setEditingSkill={setEditingSkill}
                            setAddingSkill={setAddingSkill}
                            onSave={handleSaveSkill}
                            status={status}
                        />
                    </div>
                </>
            ) : (
                <>
                    <div className="cv-skills-main-menu">
                    <SkillsList skills={skills} onEdit={handleEditSkill} onDelete={confirmDeleteSkill}/>

                    </div>
                    <button className="cv-main-menu-add" onClick={() => setAddingSkill(true)}>
                        <i className="pe-7s-plus mr-2"></i> Add another skill
                    </button>
                </>
            )}

            <ConfirmModal
                id={CONFIRM_MODAL_ID}
                title="Are you sure you want to delete this skill?"
                message="This will permanently remove the selected skill from your profile. Do you wish to proceed?"
                onConfirm={() => handleDeleteItem(skillToDelete, 'curriculumVitaeSkills')}
            />
        </div>
    );
}

export default SkillMainMenu;
